import React from 'react';
import DocView from '../components/DocView';

const DocViewPage = () => {
  return <DocView />;
};

export default DocViewPage;
